import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { Quiz } from 'components/Quiz'
import { useState, createContext, useEffect, useContext } from 'react'
import { firebaseContext } from './FirebaseContext'
import { child, get, onValue, update } from 'firebase/database'
import Evaluation from 'components/Evaluation'
import { itemcollection } from 'data/items'
import UserStatusDisplay from 'components/UserStatusDisplay'
import { useWindowSize } from 'usehooks-ts'
import { set } from 'local-storage'
const itemsPerSession = 10

const isDev = window.document.title === 'TA-Interaktiv Microfrontend'
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)

export const QuizContext = createContext<{
  userAnswers: Answer[] | undefined
  dbData: DBData | undefined
  setUserAnswers: (answers: Answer[]) => void
}>({ userAnswers: undefined, dbData: undefined, setUserAnswers: () => {} })

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [currentQuizItems, setCurrentQuizItems] = useState<Item[] | undefined>()
  const [userAnswers, setUserAnswers] = useState<Answer[]>([])
  const [dbData, setDbData] = useState<DBData | undefined>(undefined)
  const firebaseGlobals = useContext(firebaseContext)
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const [preventDB, setPreventDB] = useState(false)
  useEffect(() => {
    if (firebaseGlobals.uniqueId) readFirebaseUserData(firebaseGlobals.uniqueId)
    setPreventDB(urlParams.get('nodb') === 'true')
  }, [])

  useEffect(() => {
    if (!userAnswers.length) return
    console.log(preventDB)

    if (!preventDB) sendUserAnswersToFirebase()
    readFireBaseAnswers()
  }, [userAnswers])

  function receiveAnswers(a: Answer[]) {
    setCurrentQuizItems(undefined)
    setUserAnswers([...userAnswers, ...a])
  }

  function readFirebaseUserData(uniqueId: string) {
    get(child(firebaseGlobals.users, `${uniqueId}/`)).then((snapshot) => {
      if (snapshot.exists()) {
        setUserAnswers(snapshot.val().data)
      } else {
        setCurrentQuizItems(nextItems(itemcollection, undefined))
      }
    })
  }
  function readFireBaseAnswers() {
    get(firebaseGlobals.data).then((snapshot) => {
      // read only once
      // onValue(firebaseGlobals.data, (snapshot) => {
      // read on every change
      // console.log('snapshot', snapshot.val())
      if (snapshot.exists()) {
        setDbData(snapshot.val())
      }
    })
  }

  const sendUserAnswersToFirebase = () => {
    if (!userAnswers) return
    update(child(firebaseGlobals.users, `${firebaseGlobals.uniqueId}/`), {
      data: userAnswers,
    })
  }

  function handleRestart() {
    setCurrentQuizItems(nextItems(itemcollection, userAnswers))
  }

  return (
    <AppContainer $colorMode={colorMode}>
      {isDev && (
        <button
          style={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            pointerEvents: 'all',
            zIndex: 100,
          }}
          onClick={() => {
            localStorage.removeItem('recyclingID')
          }}
        >
          RESET
        </button>
      )}
      <QuizContext.Provider value={{ userAnswers, dbData, setUserAnswers }}>
        <TextWidth>
          <>
            {!currentQuizItems && (
              <UserStatusDisplay
                isMobile={isMobile}
                userAnswers={userAnswers}
                totalItems={itemcollection.length}
                startNext={handleRestart}
              />
            )}
          </>
          <>
            {currentQuizItems && (
              <Quiz
                isMobile={isMobile}
                items={currentQuizItems}
                returnAnswers={receiveAnswers}
              />
            )}
          </>
        </TextWidth>
        {!!(userAnswers && userAnswers.length) && (
          <Evaluation userAnswers={userAnswers} colorMode={colorMode} />
        )}
        <TextWidth>
          <>
            {!userAnswers.length && (
              <AnswerForEvaluation>
                Ordnen Sie {itemsPerSession} Produkte zu um die Auswertung zu
                sehen.
              </AnswerForEvaluation>
            )}
          </>
        </TextWidth>
      </QuizContext.Provider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 90px;
  margin-top: 60px;
`
export default MainComponent
function nextItems(allItems: Item[], allreadyAnswered: Answer[] | undefined) {
  var answeredIds = allreadyAnswered?.map((m) => m.item) || []
  var notAnswered = allItems.filter((f) => !answeredIds.includes(f.id))

  const shuffledItems = notAnswered
    .sort(() => Math.random() - 0.5)
    .slice(0, itemsPerSession)

  return shuffledItems
}

const AnswerForEvaluation = styled.div`
  width: calc(100% - 60px);
  border: 1px solid var(--gray-3);
  padding: 60px 30px;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 90px;
`
